import { Edit } from '@material-ui/icons'
import { Button, DatePicker, Form, Input, message, Modal } from 'antd'
import moment from 'moment'
import React, { useEffect } from 'react'
import { useState } from 'react'
import TableWithoutPagination from '../../../Components/TableComponents/MUITableWithoutPagination'
import { getLastCompletedWorkOrders, submitLastCompletedTask } from '../../../Services/LocomotiveServices'


const LastTaskCompletedModal = ({ open, close, modalData, setReloadState: reload }) => {

    const [form] = Form.useForm()
    const [loader, setLoader] = useState(false)
    const [lastCompletedWorkOrders, setLastCompletedWorkOrders] = useState([])
    const [editableKeys, setEditableKeys] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [editAllTasksModalInput, setEditAllTasksModalInput] = useState(undefined)

    const onClickEdit = (record, index) => {
        setEditableKeys([...editableKeys, record?.id])
        form.setFieldsValue({
            [`tasks[${index}]`]: record?.WorkCompleted ? moment(record?.WorkCompleted)?.utc() : undefined
        });
    }

    const onClickEditAllTasks = () => {
        setIsModalOpen(false)
        let newEditableKeys = lastCompletedWorkOrders?.map(x => x?.id)
        setEditableKeys(newEditableKeys)
        lastCompletedWorkOrders?.forEach((x, i) => {
            form.setFieldsValue({
                [`tasks[${i}]`]: editAllTasksModalInput ? moment(editAllTasksModalInput)?.utc() : undefined
            });
        })
    }

    const onClickCancel = (record, index) => {
        let temp = [...editableKeys]
        temp = temp.filter(x => x !== record?.id)
        setEditableKeys(temp)
        form.setFieldsValue({
            [`tasks[${index}]`]: undefined
        });
    }

    let tableData = {
        header: ["ID", "Task", "Notes", "Completed Date", ""],
        rows: lastCompletedWorkOrders?.map((x, i) => [
            x?.id,

            x?.TaskId ? x?.EquipWOTaskDD?.Task : "N/A",
            x?.Notes || "N/A",

            editableKeys?.includes(x?.id)
                ? <Form.Item name={`tasks[${i}]`} style={{ margin: 0 }} rules={[{ required: true, message: "Please select date!" }]}>
                    <DatePicker
                        format={"MM-DD-YYYY"}
                        disabledDate={current => {
                            const utcEndOfDay = moment().utc().endOf('day');
                            return current && current.isAfter(utcEndOfDay);
                        }} />
                </Form.Item>
                : x?.WorkCompleted
                    ? moment(x?.WorkCompleted)?.utc()?.format("MM-DD-YYYY")
                    : "N/A",
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                {editableKeys?.includes(x?.id)
                    ? <span
                        style={{ background: "white", color: "#2863AD", padding: "5px 10px", border: "1px solid gray", borderRadius: "8px", cursor: "pointer" }}
                        onClick={() => onClickCancel(x, i)}
                    >
                        cancel
                    </span>
                    : modalData?.values?.Status === "Reviewed-Approved" ? <></> : <Edit className="editTableIcon" onClick={() => onClickEdit(x, i)} />
                }
            </div>
        ])
    }

    const fetchLastCompletedWorkOrders = async () => {
        let res = await getLastCompletedWorkOrders(modalData?.values?.id, modalData?.values?.Status === "Reviewed-Approved" ? "Closed" : "Completed")
        if (res?.httpStatus === 200) {
            setLastCompletedWorkOrders(res?.data)
        }
    }

    useEffect(() => {
        if (open) fetchLastCompletedWorkOrders()
    }, [open])


    const onSubmitForm = async (values) => {

        const tasksArray = lastCompletedWorkOrders.map((_, i) => {
            return {
                id: _?.id,
                date: values[`tasks[${i}]`] ? moment(values[`tasks[${i}]`])?.utc()?.format("MM-DD-YYYY") : moment(_?.WorkCompleted)?.utc()?.format("MM-DD-YYYY")
            }
        })

        let body = {
            comments: values?.comments,
            tasks: [...tasksArray]
        }

        setLoader(true)
        let res = await submitLastCompletedTask(modalData?.values?.id, body)
        if (res?.httpStatus === 200) {
            close()
            message?.success("Last task updated successfully")
            setEditableKeys([])
            form.resetFields()
            setEditAllTasksModalInput(undefined)
            reload(prev => prev = !prev)
            setLoader(false)
        }
        setLoader(false)
    }

    return (
        <Modal
            open={open}
            onCancel={() => {
                close()
                setEditableKeys([])
                form.resetFields()
                setEditAllTasksModalInput(undefined)
            }}
            footer={null}
            title={<span style={{ fontWeight: 'bold' }}>{modalData?.values?.EquipMaster?.EquipUID || "No Equipment UID Available"}</span>}
            width={1200}
        >
            <Form onFinish={onSubmitForm} form={form}>
                <div style={{ display: "flex", flexDirection: "column", gap: "25px" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "30% 70%", alignItems: "center" }}>
                            <span style={{ fontSize: "13px" }}>Edit Comments</span>
                            <Form.Item name="comments" style={{ margin: 0 }} rules={[{ required: true, message: "Please enter comments!" }]}>
                                <Input disabled={modalData?.values?.Status === "Reviewed-Approved"} />
                            </Form.Item>
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-start" }}>
                        <Button
                            style={{ background: "white", color: "#2863AD", padding: "5px 10px", border: "1px solid gray", borderRadius: "8px", cursor: "pointer", opacity: lastCompletedWorkOrders?.length > 0 ? "1" : "0.4" }}
                            onClick={() => setIsModalOpen(true)}
                            disabled={lastCompletedWorkOrders?.length > 0 ? modalData?.values?.Status === "Reviewed-Approved" ? true : false : true}
                        >
                            Edit All Tasks
                        </Button>
                    </div>
                    <TableWithoutPagination tableData={tableData} />
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <button
                            style={{ background: "#2863AD", color: "white", padding: "5px 20px", border: "none", borderRadius: "8px", cursor: "pointer" }}
                            type="submit"
                            disabled={modalData?.values?.Status === "Reviewed-Approved" || loader}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </Form>
            <Modal
                open={isModalOpen}
                onCancel={() => {
                    setIsModalOpen(false)
                    setEditAllTasksModalInput(undefined)
                }}
                footer={null}
                title="Edit All tasks"
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <DatePicker
                        value={editAllTasksModalInput}
                        onChange={e => setEditAllTasksModalInput(e)}
                        format="MM-DD-YYYY"
                        disabledDate={current => current && current > moment().endOf('day')}

                    />
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <button
                            style={{ background: "#2863AD", color: "white", padding: "5px 20px", border: "none", borderRadius: "8px", cursor: "pointer" }}
                            disabled={!editAllTasksModalInput ? true : false}
                            onClick={() => onClickEditAllTasks()}
                        >
                            Update
                        </button>
                    </div>
                </div>
            </Modal>
        </Modal>
    )
}

export default LastTaskCompletedModal